import { render, staticRenderFns } from "./e-link.vue?vue&type=template&id=600d49a6&scoped=true&lang=pug"
import script from "./e-link.vue?vue&type=script&lang=js"
export * from "./e-link.vue?vue&type=script&lang=js"
import style0 from "./e-link.vue?vue&type=style&index=0&id=600d49a6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "600d49a6",
  null
  
)

export default component.exports